import React from 'react'
import { useLocation, useParams } from 'react-router-dom'

export const withRouter = (Component: any) => (props: any) => {
  const location = useLocation()
  const params = useParams()
  
  return <Component location={location} params={params} {...props} />
}
